var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.7 89.6l-53.4-44.1c-3.8-3.1-9.4-.3-9.4 4.7V66c0 3.2-2.4 5.8-5.5 6-51.5 3-77.5 48.3-85.2 74.2-.4 1.2 1.1 2.1 1.9 1.1 16.6-18.8 39.3-30.5 74.8-30.5h8.2c3.2 0 5.8 2.7 5.8 6v15.6c0 5 5.6 7.9 9.4 4.7L175.7 99c2.9-2.4 2.9-7 0-9.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAgMjAwIj48ZGVmcy8+PHBhdGggZD0iTTE3NS43IDg5LjZsLTUzLjQtNDQuMWMtMy44LTMuMS05LjQtLjMtOS40IDQuN1Y2NmMwIDMuMi0yLjQgNS44LTUuNSA2LTUxLjUgMy03Ny41IDQ4LjMtODUuMiA3NC4yLS40IDEuMiAxLjEgMi4xIDEuOSAxLjEgMTYuNi0xOC44IDM5LjMtMzAuNSA3NC44LTMwLjVoOC4yYzMuMiAwIDUuOCAyLjcgNS44IDZ2MTUuNmMwIDUgNS42IDcuOSA5LjQgNC43TDE3NS43IDk5YzIuOS0yLjQgMi45LTcgMC05LjR6Ii8+PC9zdmc+";
export { ForwardRef as ReactComponent };